module.exports = __webpack_public_path__ + "img/documentLogo.8be3603f.svg";